var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15H1V1H6V5.5V6H6.5H11V15ZM7 1.16562L10.8344 5H7V1.16562ZM7.25 0H1H0V1V15V16H1H11H12V15V4.75L7.25 0ZM3.5 8H3V9H3.5H8.5H9V8H8.5H3.5ZM3.5 10H3V11H3.5H8.5H9V10H8.5H3.5ZM3.5 12H3V13H3.5H8.5H9V12H8.5H3.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperNotificationIcon);
export default __webpack_public_path__ + "static/media/paper-notification-icon.4a6d4afeb96bf2a3a5600e8484f804f5.svg";
export { ForwardRef as ReactComponent };